<template>
  <div class="customers-container">
    <el-card class="filter-card">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="单位名称">
          <el-input v-model="filterForm.name" placeholder="请输入单位名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div class="table-header">
        <div class="header-left">
          <span class="title">客户列表</span>
          <span class="count">共 {{ totalItems }} 条</span>
        </div>
        <div class="header-right">
          <el-button type="success" icon="el-icon-plus" @click="addCustomer">新增客户</el-button>
        </div>
      </div>
      
      <el-table
        :data="customerList"
        border
        v-loading="tableLoading"
        style="width: 100%">
        <template slot="empty">
          <div class="empty-block">
            <p class="empty-text">{{ tableLoading ? '加载中...' : '暂无数据' }}</p>
          </div>
        </template>
        <el-table-column
          type="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="单位名称"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="customerCode"
          label="客户编号"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="contactPerson"
          label="联系人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="130">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status === 1 ? '正常' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="注册时间"
          width="160">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="200">
          <template slot-scope="scope">
            <div class="operation-buttons">
              <el-button size="mini" type="primary" @click="editCustomer(scope.row)">编辑</el-button>
              <el-button size="mini" type="warning" @click="resetPassword(scope.row)">重置密码</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="pageSize"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>

    <customer-form
      :visible.sync="formVisible"
      :is-edit="isEdit"
      :customer-data="currentCustomer"
      @success="handleFormSuccess"
    />
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'
import CustomerForm from './CustomerForm.vue'

export default {
  name: 'Customers',
  components: {
    CustomerForm
  },
  data() {
    return {
      filterForm: {
        name: '',
        status: ''
      },
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      customerList: [],
      formVisible: false,
      isEdit: false,
      currentCustomer: {}
    }
  },
  created() {
    this.fetchCustomers()
  },
  methods: {
    async fetchCustomers() {
      this.tableLoading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          companyName: this.filterForm.name,
          status: this.filterForm.status || null
        }
        const res = await adminApi.getCustomerListByPage(params)
        if (res.data.code === 200) {
          this.customerList = Array.isArray(res.data.data) ? res.data.data : []
          this.totalItems = res.data.count || 0
        } else {
          this.customerList = []
          this.totalItems = 0
          this.$message.error(res.msg || '获取客户列表失败')
        }
      } catch (error) {
        this.customerList = []
        this.totalItems = 0
        this.$message.error(error.msg || '获取客户列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.fetchCustomers()
    },
    resetFilter() {
      this.filterForm = {
        name: '',
        status: ''
      }
      this.handleFilter()
    },
    handleSizeChange() {
      this.fetchCustomers()
    },
    handleCurrentChange() {
      this.fetchCustomers()
    },
    getStatusType(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status] || 'info'
    },
    addCustomer() {
      this.isEdit = false
      this.currentCustomer = {}
      this.formVisible = true
    },
    editCustomer(row) {
      this.isEdit = true
      this.currentCustomer = { ...row }
      this.formVisible = true
    },
    resetPassword(row) {
      this.$confirm(`确定要重置客户 ${row.companyName} 的密码吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await adminApi.resetCustomerPassword(row.id)
          this.$message.success(`客户 ${row.companyName} 的密码已重置`)
        } catch (error) {
          this.$message.error(error.msg || '重置密码失败')
        }
      }).catch(() => {})
    },
    handleFormSuccess() {
      this.fetchCustomers()
    }
  }
}
</script>

<style scoped>
.customers-container {
  padding: 20px 0;
}

.filter-card {
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.table-card {
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.count {
  color: #909399;
  font-size: 14px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.operation-buttons {
  display: flex;
  gap: 8px;
}

.empty-block {
  padding: 30px 0;
  text-align: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.empty-text {
  color: #909399;
  font-size: 14px;
  margin: 0;
}
</style> 